export enum NoteTypeEnum {
  Complaint = 6,
  Rider = 0,
  ProviderNegotiated = 56,
  ClientNegotiated = 57,
  Billing = 34,
  Negotiated = 49,
  Member = 7
}



// WEBPACK FOOTER //
// ./src/app/core/enums/note-type.enum.ts